export enum CommonExpressionsEventType {
  COMMON_EXPRESSIONS_OUTCOME_EVENT = 'common_expressions_outcome_event',
  COMMON_EXPRESSIONS_REPORT_ACTIVITY_PROGRESS_EVENT = 'common_expressions_report_activity_progress_event',
  COMMON_EXPRESSIONS_CLOSE_EVENT = 'common_expressions_close_event',
  COMMON_EXPRESSIONS_HEIGHT_EVENT = 'common_expressions_height_event',
}





// WEBPACK FOOTER //
// ./ts/app/shared/types/common-expressions-events.enum.ts